export default __webpack_public_path__ + "static/chaos-not-so-good-1809e48e342bfaaccb57e23416f983cc.png";